var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgitar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 30,
    viewBox: "0 0 170 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52329 13.3514C0.742238 14.1325 0.742238 15.3988 1.52329 16.1798L14.2512 28.9078C15.0323 29.6888 16.2986 29.6888 17.0796 28.9078C17.8607 28.1267 17.8607 26.8604 17.0796 26.0793L5.76593 14.7656L17.0796 3.45192C17.8607 2.67087 17.8607 1.40454 17.0796 0.623489C16.2986 -0.15756 15.0323 -0.15756 14.2512 0.623489L1.52329 13.3514ZM70.6683 12.7656L2.9375 12.7656L2.9375 16.7656L70.6683 16.7656L70.6683 12.7656Z",
    fill: "#FFC427"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.449 16.3986C169.23 15.6175 169.23 14.3512 168.449 13.5702L155.721 0.842239C154.94 0.0611901 153.674 0.06119 152.893 0.842239C152.112 1.62329 152.112 2.88962 152.893 3.67067L164.207 14.9844L152.893 26.2981C152.112 27.0791 152.112 28.3455 152.893 29.1265C153.674 29.9076 154.94 29.9076 155.721 29.1265L168.449 16.3986ZM99.3044 16.9844L167.035 16.9844L167.035 12.9844L99.3044 12.9844L99.3044 16.9844Z",
    fill: "#FFC427"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgitar);
export default __webpack_public_path__ + "static/media/Agitar.21605da3d7d7946749d766f0e87c557b.svg";
export { ForwardRef as ReactComponent };